import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/knowledge/page';

export const Route = createFileRoute('/_app/settings/knowledge/')({
  component: Page,
});
